// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 获取用户钱包GetUserReply
// Req : open_proto.client.v1.user.SelectWalletReq
// Resp: open_proto.common.SuccessResp
export const selectWallet = (data) => {
  return service({
    url: '/v1/user/selectWallet',
    method: 'post',
    data
  })
}
// 获取用户钱包
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.user.GetWalletResp
export const getWallet = (data) => {
  return service({
    url: '/v1/user/getWallet',
    method: 'post',
    data
  })
}
// 获取用户提现账户
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.user.WithdrawAccountResp
export const getWithdrawAccount = (data) => {
  return service({
    url: '/v1/user/getWithdrawAccount',
    method: 'post',
    data
  })
}
// 更新用户提现账户
// Req : open_proto.client.v1.user.UpdateWithdrawAccountReq
// Resp: open_proto.common.ModifyResp
export const updateWithdrawAccount = (data) => {
  return service({
    url: '/v1/user/updateWithdrawAccount',
    method: 'post',
    data
  })
}
// 根据sid获取用户信息
// Req : open_proto.client.v1.user.GetUserReq
// Resp: open_proto.client.v1.user.GetUserReply
export const getUser = (data) => {
  return service({
    url: '/v1/user/getUser',
    method: 'post',
    data
  })
}
// 用户注册
// Req : open_proto.client.v1.user.RegisterReq
// Resp: open_proto.client.v1.user.AccessTokenReply
export const register = (data) => {
  return service({
    url: '/v1/user/register',
    method: 'post',
    data
  })
}
// 用户登录
// Req : open_proto.client.v1.user.LoginReq
// Resp: open_proto.client.v1.user.AccessTokenReply
export const login = (data) => {
  return service({
    url: '/v1/user/login',
    method: 'post',
    data
  })
}
// 获取用户CPF账户类型
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.user.CpfAccountResp
export const cpfAccountType = (data) => {
  return service({
    url: '/v1/user/cpfAccount',
    method: 'post',
    data
  })
}
// 修改用户信息
// Req : open_proto.client.v1.user.UpdateUserReq
// Resp: open_proto.common.SuccessResp
export const updateUser = (data) => {
  return service({
    url: '/v1/user/updateUser',
    method: 'post',
    data
  })
}
// 获取验证码
// Req : open_proto.client.v1.user.GetCaptchaReq
// Resp: open_proto.client.v1.user.GetCaptchaResp
export const getCaptcha = (data) => {
  return service({
    url: '/v1/user/getCaptcha',
    method: 'post',
    data
  })
}
// 获取邮箱验证码
// Req : open_proto.client.v1.user.GetEmailCaptchaReq
// Resp: open_proto.client.v1.user.GetEmailCaptchaResp
export const getEmailCaptcha = (data) => {
  return service({
    url: '/v1/user/getEmailCaptcha',
    method: 'post',
    data
  })
}
// 重置密码
// Req : open_proto.client.v1.user.ResetPasswordReq
// Resp: open_proto.client.v1.user.ResetPasswordResp
export const resetPassword = (data) => {
  return service({
    url: '/v1/user/resetPassword',
    method: 'post',
    data
  })
}
// 用户VIP流水
// Req : open_proto.client.v1.user.VipFlowReq
// Resp: open_proto.client.v1.user.VipFlowResp
export const vipFlow = (data) => {
  return service({
    url: '/v1/user/vipFlow',
    method: 'post',
    data
  })
}
// 退出登录
// Req : open_proto.common.Undefined
// Resp: open_proto.common.SuccessResp
export const loginOut = (data) => {
  return service({
    url: '/v1/user/loginOut',
    method: 'post',
    data
  })
}
// 第三方注册
// Req : open_proto.client.v1.user.ThirdLoginReq
// Resp: open_proto.client.v1.user.AccessTokenReply
export const thirdLogin = (data) => {
  return service({
    url: '/v1/user/thirdLogin',
    method: 'post',
    data
  })
}
// 用户反馈
// Req : open_proto.client.v1.user.FeedbackReq
// Resp: open_proto.common.SuccessResp
export const feedback = (data) => {
  return service({
    url: '/v1/user/feedback',
    method: 'post',
    data
  })
}
// 保存用户pwa信息
// Req : open_proto.client.v1.user.PwaSaveReq
// Resp: open_proto.common.SuccessResp
export const pwaSave = (data) => {
  return service({
    url: '/v1/user/pwaSave',
    method: 'post',
    data
  })
}
// 更新用户语言
// Req : open_proto.client.v1.user.UpdateUserLanguageReq
// Resp: open_proto.common.SuccessResp
export const updateUserLanguage = (data) => {
  return service({
    url: '/v1/user/updateUserLanguage',
    method: 'post',
    data
  })
}
// 更新用户分享标识
// Req : open_proto.common.Undefined
// Resp: open_proto.common.SuccessResp
export const updateUserShare = (data) => {
  return service({
    url: '/v1/user/updateUserShare',
    method: 'post',
    data
  })
}
// 三方绑定
// Req : open_proto.client.v1.user.ThirdBindReq
// Resp: open_proto.common.SuccessResp
export const thirdBind = (data) => {
  return service({
    url: '/v1/user/thirdBind',
    method: 'post',
    data
  })
}
// 获取风险偏好设置详情
// Req : open_proto.client.v1.user.GetRiskPreferenceInfoReq
// Resp: open_proto.client.v1.user.RiskPreferenceInfo
export const getRiskPreferenceInfo = (data) => {
  return service({
    url: '/v1/user/getRiskPreferenceInfo',
    method: 'post',
    data
  })
}
// 更新风险偏好设置
// Req : open_proto.client.v1.user.RiskPreference
// Resp: open_proto.common.SuccessResp
export const updateRiskPreference = (data) => {
  return service({
    url: '/v1/user/updateRiskPreference',
    method: 'post',
    data
  })
}
// 更新accessToken
// Req : open_proto.client.v1.user.RefreshAccessTokenReq
// Resp: open_proto.client.v1.user.RefreshAccessTokenResp
export const refreshAccessToken = (data) => {
  return service({
    url: '/v1/user/refreshAccessToken',
    method: 'post',
    data
  })
}
// 绑定cpf
// Req : open_proto.client.v1.user.BindCpfReq
// Resp: open_proto.client.v1.user.BindCpfResp
export const bindCpf = (data) => {
  return service({
    url: '/v1/user/bindCpf',
    method: 'post',
    data
  })
}
// 获取限制记录
// Req : open_proto.client.v1.user.RiskPreferenceTriggerRecordReq
// Resp: open_proto.client.v1.user.RiskPreferenceTriggerRecordResp
export const getRiskPreferenceTriggerRecord = (data) => {
  return service({
    url: '/v1/user/getRiskPreferenceTriggerRecord',
    method: 'post',
    data
  })
}
// 获取用户指标
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.user.UserMetricsResp
export const getUserMetrics = (data) => {
  return service({
    url: '/v1/user/getUserMetrics',
    method: 'post',
    data
  })
}
// Vip展示
// Req : open_proto.client.v1.user.VipDisplayReq
// Resp: open_proto.client.v1.user.VipDisplayResp
export const vipDisplay = (data) => {
  return service({
    url: '/v1/user/vipDisplay',
    method: 'post',
    data
  })
}
// 拉取Messenger用户列表
// Req : open_proto.client.v1.user.MessengerUserListReq
// Resp: open_proto.client.v1.user.MessengerUserListResp
export const getMessengerUserList = (data) => {
  return service({
    url: '/v1/user/getMessengerUserList',
    method: 'post',
    data
  })
}
// Messenger用户送金
// Req : open_proto.client.v1.user.MessengerSendGoldReq
// Resp: open_proto.common.SuccessResp
export const messengerSendGold = (data) => {
  return service({
    url: '/v1/user/messengerSendGold',
    method: 'post',
    data
  })
}
// 创建Messenger用户
// Req : open_proto.client.v1.user.MessengerUser
// Resp: open_proto.client.v1.user.MessengerUser
export const createMessengerUser = (data) => {
  return service({
    url: '/v1/user/createMessengerUser',
    method: 'post',
    data
  })
}
// 获取三方绑定信息
// Req : open_proto.client.v1.user.GetThirdBindInfoReq
// Resp: open_proto.client.v1.user.GetThirdBindInfoResp
export const getThirdBindInfo = (data) => {
  return service({
    url: '/v1/user/getThirdBindInfo',
    method: 'post',
    data
  })
}
// 保存用户Firebase信息
// Req : open_proto.client.v1.user.FirebaseSaveReq
// Resp: open_proto.common.SuccessResp
export const firebaseSave = (data) => {
  return service({
    url: '/v1/user/firebaseSave',
    method: 'post',
    data
  })
}
// 点击事件统计
// Req : open_proto.client.v1.user.ClickEventReq
// Resp: open_proto.common.SuccessResp
export const clickEvent = (data) => {
  return service({
    url: '/v1/user/clickEvent',
    method: 'post',
    data
  })
}
// 特色模块提现引导是否展示文案
// Req : open_proto.client.v1.user.WithdrawGuideShowTextReq
// Resp: open_proto.client.v1.user.WithdrawGuideShowTextResp
export const withdrawGuideShowText = (data) => {
  return service({
    url: '/v1/user/withdrawGuideShowText',
    method: 'post',
    data
  })
}
